<template>
  <div class="modal fade" id="modal-terms" tabindex="-1" role="dialog" aria-labelledby="modal-terms" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $starLabelPlural | sentenceCase }} Selected</h4>
        </div>
        <div class="talent-list modal-body">
          <ul>
            <li class="talent-name" v-for="talent of talents" :key="talent.id">{{talent.name}}</li>
          </ul>
        </div>

        <div class="modal-header" v-if="!$vlastMode">
          <h4 class="modal-title">Terms and Conditions</h4>
        </div>

        <div class="modal-body" v-if="!$vlastMode">
          <p class="lead">
            Please read the full <a :href="bookingTncLink()" target="_blank">Terms & Conditions here</a>, then agree to proceed with your booking.
          </p>

          <ul class="terms-and-conditions">
            <li>
              <div class="form-group">
                <div class="checkbox checkbox-primary">
                  <input
                    type="checkbox"
                    name="term_one"
                    id="term_one"
                    disabled
                    checked/>

                  <label for="term_one">
                    You'll stick to the brief. You will not ask the {{ $starLabel }} to do anything that is not written and agreed to e.g. stay at the event for longer, extra social media posts etc.
                  </label>
                </div>
              </div>
            </li>

            <li>
              <div class="form-group">
                <div class="checkbox checkbox-primary checkbox-lg">
                  <input
                    type="checkbox"
                    name="term_two"
                    id="term_two"
                    disabled
                    checked/>

                  <label for="term_two">
                    You'll only use approved promotional images. For example, you won't use photos of athletes wearing league licensed attire or other licensed imagery for promotional purposes (eg featuring league logos, club logos, team sponsor logos).
                  </label>
                </div>
              </div>
            </li>

            <li>
              <div class="form-group">
                <div class="checkbox checkbox-primary">
                  <input
                    type="checkbox"
                    name="term_three"
                    id="term_three"
                    disabled
                    checked/>

                  <label for="term_three">
                    You need to pay your deposit urgently. You understand that until the deposit is paid, the talent may accept other booking requests (unless otherwise agreed upon by {{ this.clientName }}).
                  </label>
                </div>
              </div>
            </li>
          </ul>

        </div>

        <div class="modal-footer">
          <button class="btn btn-danger btn-lg pull-left" data-dismiss="modal" @click="hide">Cancel</button>
          <ladda-button
            class="btn btn-primary btn-lg"
            :disabled="cannotAcceptTermsAndConditions"
            :click="handleAcceptTermsAndConditionsCallback"
            v-html="$vlastMode ? 'Confirm Booking' : 'I Agree'">

          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { notify } from 'utils'
import $ from 'jquery'
import BookingTnc from 'mixins/tnc'
import { OpportunityTracker } from 'mixins/analytics'

const defaultTerms = () => ({
  one: true,
  two: true,
  three: true
})

export default {
  mixins: [OpportunityTracker, BookingTnc],
  props: {
    booking: {
      required: true,
      type: Object
    },
    propertyMutator: {
      required: true,
      type: Function
    },
    talents: {
      required: true,
      type: Array
    }
  },

  data () {
    return {
      terms: defaultTerms(),
      promise: null
    }
  },

  computed: {
    /**
     * Determine if terms cannot be accepted due to one not being checked.
     *
     * @return bool
     */
    cannotAcceptTermsAndConditions () {
      return !this.terms.one ||
        !this.terms.two ||
        !this.terms.three
    }
  },

  methods: {
    ...mapActions('booking', ['acceptTermsAndConditions', 'declineTermsAndConditions']),

    /**
     * Show the modal.
     *
     * Pass in a promise that should be resolved/rejected based on the acceptance of terms.
     *
     * @param Promise promise
     *
     * @return void
     */
    show (promise) {
      this.promise = promise

      $(this.$el)
        .modal('show')

      $(this.$el).one('hidden.bs.modal', this.handleCancelCallback)
    },
    /**
     * Hide the modal.
     */
    hide () {
      $(this.$el).modal('hide')
    },
    /**
     * Handle accepting the terms and conditions.
     *
     * @return Promise
     */
    handleAcceptTermsAndConditionsCallback () {
      const payload = {
        terms: this.terms
      }
      this.trackEvent(this.analytics.V2.JobTermsAcceptEvent)
      return this.acceptTermsAndConditions({ id: this.booking.id, payload })
        .then((response) => {
          const modal = $(this.$el)

          modal.off('hidden.bs.modal', this.handleCancelCallback)
          modal.one('hidden.bs.modal', () => {
            if (this.promise) {
              this.promise.resolve()
            }

            this.propertyMutator({ property: 'client_accepted_terms', value: response.data.client_accepted_terms })
            this.propertyMutator({ property: 'status', value: response.data.status })
          })

          modal.modal('hide')
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            notify.error(error.response.data.message)
          } else {
            notify.error('You must accept all the terms and conditions to continue.')
          }
        })
    },

    /**
     * Handle cancelling the acceptance of terms and conditions.
     */
    handleCancelCallback () {
      if (this.promise) {
        this.promise.reject(new Error('cancelled'))
      }

      this.terms = defaultTerms()

      const payload = {
        terms: this.terms
      }
      this.trackEvent(this.analytics.V2.JobTermsCancelEvent)
      return this.declineTermsAndConditions({ id: this.booking.id, payload })
    }
  }
}
</script>

<style scoped>
  .talent-list {
    padding: 0 !important;
  }

  .talent-list ul {
    margin-bottom: 0 !important;
  }

  .talent-name {
    color: var(--brand-primary);
    padding: 12px 25px;
    list-style: none;
    font-size: 20px;
    font-weight: bold;
  }
</style>
